<template>
  <div class="layout">
    <!-- 头部导航 -->

    <header class="header">
      <div class="header-container">
        <div class="header-content">
          <div class="logo">
            <router-link to="/index">
              <p style="font-size:24px;font-weight: 600;text-wrap:nowrap ;">{{ $t('layout.header.logo.zh') }}</p>
              <p style="font-size:24px;font-weight: 600;color:var(--secondary);text-wrap:nowrap">{{ $t('layout.header.logo.en') }}</p>
            </router-link>
          </div>


          <div style="width:100%;">
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;padding:7px 10px 0 0;">
              <div class="search-container">
                <div class="search-box">
                  <i class="el-icon-search search-icon"
                    style="margin-right:10px;color:rgb(17, 99, 167);font-weight: 600;;"></i>
                  <input v-model="searchQuery" @focus="btnQueryDropdown = true" @blur="btnQueryDropdown = false"
                    type="text" class="search-input" :placeholder="$t('layout.header.search.placeholder_search')">
                  <button class="searchQuery-btn" style="border-right:1px  solid #fff;" @click="querProducts(true)">
                    {{ $t('layout.header.search.btn_search') }}
                  </button>


                </div>
                <a class="searchQuery-advance-btn" @click="querProducts()">
                  {{ $t('layout.header.search.btn_advancedSearch') }}
                </a>
                <!-- <transition name="fade">
                <div v-show="btnQueryDropdown" class="searchQuery-dropdown">
          
                  <button class="searchQuery-btn" style="width:60%;" @click="querProducts()">
                    {{ $t('layout.header.search.btn_advancedSearch') }}
                  </button>
                </div>
              </transition> -->
              </div>
              <LangSelector :languages="customLanguages" @language-change="handleLanguageChange" />
            </div>
            <!-- 桌面导航 -->

            <nav class="desktop-nav" >
              <NavMenu  :navItems="navItems"></NavMenu>
            </nav>
          </div>




          <div class="mobile-menu">
            <button class="mobile-menu-btn" @click="querProducts()">
              <i class="fas fa-search"></i>
            </button>
            <button class="mobile-menu-btn" @click="toggleMobileMenu">
              <i class="iconfont" :class="showMobileMenu ? 'icon-close' : 'el-icon-menu'"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
    <!-- 移动端侧边导航 -->
    <MobileNav v-show="showMobileMenu" v-if="!loading" :showMobileNav="showMobileMenu" :navItems="navItems"
      @toggle-MobileMenu="toggleMobileMenu"></MobileNav>
    <!-- 主要内容区域 -->
    <main class="main">
      <router-view :key="$route.fullPath" />
    </main>
    <!-- 页脚 -->
    <footer class="footer custom" v-fade-in>
      <div class="footer-content">
        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('productIndex')">产品中心</h3>
          <div class="footer-menu-container" v-if="$store.state.topProductCategorys.length > 0">
            <p :key="item.id" v-for="item in $store.state.topProductCategorys"
              @click="jumpPage('productCategory', item.id)" style="cursor: pointer;">
              {{ item.name }}</p>
          </div>
        </div>
        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('solutionIndex')">解决方案</h3>
          <div class="footer-menu-container" v-if="$store.state.solutionCategorys.length > 0">
            <p :key="item.id" v-for="item in $store.state.solutionCategorys" @click="jumpPage('solutionIndex', item.id)"
              style="cursor: pointer;">
              {{ item.name }}</p>
          </div>
        </div>


        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('serviceIndex')">服务支持</h3>
          <div class="footer-menu-container" v-if="$store.state.serviceCategorys.length > 0">
            <p :key="item.id" v-for="item in $store.state.serviceCategorys" @click="jumpPage('serviceIndex', item.id)"
              style="cursor: pointer;">
              {{ item.name }}</p>
          </div>
        </div>

        <!-- 
        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('concactIndex')">联系我们</h3>
          <div class="footer-menu-container">
            <p>电话：4008-651-700</p>
            <p>邮箱：sales@xiatech.com.cn</p>
            <p>地址：西安市碑林区南二环东段31号云峰大厦</p>
          </div>
        </div> -->
        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('aboutIndex')">关于我们</h3>
          <div class="footer-menu-container">
            <p style="cursor: pointer;" @click="jumpPage('newsIndex')">新闻中心</p>
            <p style="cursor: pointer;" @click="jumpPage('aboutIndex', 'introduce')">公司简介</p>
            <p style="cursor: pointer;" @click="jumpPage('aboutIndex', 'corporateCulture')">企业文化</p>
            <!-- <p style="cursor: pointer;" @click="jumpPage('aboutIndex', 'certs')">认证与资质</p> -->
          </div>
        </div>
        <div class="footer-section">
          <h3 class="footer-title" @click="jumpPage('concactIndex')">联系我们</h3>
          <div class="footer-menu-container">
            <img src="../../public/images/ewm1.png" loading="lazy">

          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p style="font-size: 14px;display:flex;justify-content: center;align-items: center;">© {{ $store.state.siteInfo.copyright }} <span style="margin: 0 10px;">{{ $store.state.siteInfo.icpfiling }}</span> <img src="../../public/images/beian.png" style="margin:0 5px;height: 16px;width: 16px;;"> <a style="color: #ffffff;margin: 0; text-align: center;" href="https://beian.mps.gov.cn/#/query/webSearch?code=61010302001516" rel="noreferrer" target="_blank">陕公网安备61010302001516号</a> </p>
      </div>
    </footer>

    <!-- 遮罩层 -->
    <transition name="fade">
      <div class="overlay" v-show="showMobileMenu" @click="toggleMobileMenu"></div>
    </transition>

    <!-- 遮罩层 -->
    <transition name="fade">
      <div class="overlay" style="overflow: auto;" v-show="queryOption">
        <QueryProduct @QuerProducts="querProducts"></QueryProduct>
      </div>
    </transition>
  </div>
</template>

<script>
import MobileNav from './MobileNav.vue'
import NavMenu from './NavMenu.vue'
import LangSelector from './LangSelector.vue'
import NavMenuItem from './NavMenuItem.vue'
import TopBreadcrumb from './TopBreadcrumb.vue'
import { productApi, serviceApi, solutionApi, siteInfoApi } from '@/api'

import { getImageFile } from '../utils'
import QueryProduct from './product/QueryProduct.vue'

export default {
  name: 'AppLayout',
  components: {
    NavMenu, NavMenuItem, MobileNav, TopBreadcrumb, QueryProduct, LangSelector
  },
  data() {
    return {
      loading: true,
      searchQuery: '',
      queryOption: false,
      isTopMenu: true,
      showMobileMenu: false,
      btnQueryDropdown: false,
      showDropdown: null, // 当前显示的桌面端下拉菜单
      customLanguages: [
        { code: 'zh', name: '中文', flag: 'flag-cn' },
        { code: 'en', name: 'English', flag: 'flag-us' },
        // { code: 'fr', name: 'Français', flag: 'flag-fr' }
      ],
      breadcrumbData: [],
      topProductCategories: [],
      productCategories: [],
      serviceCategories: [],
      solutionCategories: [],
    }
  },
  computed: {
    navItems() {

      return [

        {
          id: 'products',
          title: this.$t('layout.header.nav.products'),
          enTitle: 'Products',
          path: '/products',
          menuItem: []
        },
        {
          id: 'solutions',
          title: this.$t('layout.header.nav.solutions'),
          enTitle: 'Solutions',
          path: '/solutions',
          menuItem: []
        },
        {
          id: 'services',
          title: this.$t('layout.header.nav.services'),
          enTitle: 'Services',
          path: '/services',
          menuItem: []
        },
        {
          id: 'about',
          title: this.$t('layout.header.nav.about'),
          enTitle: 'About Us',
          path: '/about',
          menuItem: []
        },
        {
          id: 'contact',
          title: this.$t('layout.header.nav.contact'),
          enTitle: 'Contact Us',
          path: '/contact',
          menuItem: []
        }
      ]
    }
  },
  async mounted() {
    // // 监听全局路由变化
    // this.$router.beforeEach((to, from, next) => {


    //   next(); // 必须调用 next()

    // })
  },
  destroyed() {
  },
  async created() {
    this.loadData()
  },
  methods: {
    getImageFile,
    async loadData() {
      try {
        // 并行请求示例
        const [productCategoryTreeRes, topProductCategorysRes, solutionCategoryRes, serviceCoategoriesRes, companyInfoRes, siteInfoRes] = await Promise.all([
          productApi.getProductCategoryTree({ status: 1 }),
          productApi.getProductCategories({ status: 1 }),
          solutionApi.getCategorys({ status: 1 }),
          serviceApi.getServiceCoategories({ status: 1 }),
          siteInfoApi.getCompanyInfo(),
          siteInfoApi.getSiteInfo()

        ])
        this.$store.commit('SET_SITEINFO', siteInfoRes[0]);
        this.$store.commit('SET_COMPANYINFO', companyInfoRes[0]);
        this.serviceCategories = serviceCoategoriesRes.items || serviceCoategoriesRes
        // await  this.serviceCategories.map(async item =>{
        //   item.imageUrl =await getImageFile(this.$globalUploadArr + item.imageUrl)
        // })
        //console.log("this.serviceCategories =            =  ", this.serviceCategories)
        this.productCategories = productCategoryTreeRes || productCategoryTreeRes.items
        this.topProductCategories = productCategoryTreeRes || productCategoryTreeRes.items//topProductCategorysRes.items || topProductCategorysRes
        this.solutionCategories = solutionCategoryRes.items || solutionCategoryRes


        this.$store.commit('SET_PRODUCTCATEGORYS', this.productCategoriess);
        this.$store.commit('SET_SOLUTIONCATEGORYS', this.solutionCategories);
        this.$store.commit('SET_SERVICECATEGORYS', this.serviceCategories);
        this.$store.commit('SET_TOPPRODUCTCATEGORYS', this.topProductCategories);

      } catch (error) {
        console.error('数据加载失败:', error)
      } finally {
        this.navItems[0].menuItem = this.$store.state.topProductCategorys
        this.navItems[1].menuItem = this.$store.state.solutionCategorys
        this.navItems[2].menuItem = this.$store.state.serviceCategorys
        this.loading = false
      }

    },
    handleLanguageChange(lang) {
      console.log('语言已更改为:', lang);
      //   // 1. 更新 Vue I18n
      //   this.$i18n.locale = lang;

      // // 2. 更新 HTML lang 属性
      // document.documentElement.lang = lang;

      // // 3. 保存到 localStorage
      // localStorage.setItem('user-language', lang);

      // // 4. 更新 Vuex（如果使用）
      // if (this.$store) {
      //   this.$store.commit('SET_LANGUAGE', lang);
      // }

      // 5. 更新所有 API 配置
      // switchApiLanguage(lang);
    },
    // toggleMobileMenu() {
    //   this.showMobileMenu = !this.showMobileMenu
    //   // 切换body的overflow属性防止滚动
    //   document.body.style.overflow = this.showMobileMenu ? 'hidden' : 'auto'
    // }
    async querProducts(status) {
      // console.log("querProducts".status)
      // this.queryOption = status;
      this.$router.push({ name: "Search", query: { keyword: this.searchQuery, timestamp: Date.now() } })

    },
    async jumpPage(str, id = null) {
      if (str === "productCategory") {

        this.$router.push({ path: "/products/category", query: { id: id } })
      }
      if (str === "solutionIndex") {

        this.$router.push({ path: "/solutions/index", query: { id: id } })
      }
      if (str === "productIndex") {

        this.$router.push({ path: "/products/index" })
      }
      if (str === "concactIndex") {

        this.$router.push({ path: "/contact" })
      }
      if (str === "newsIndex") {

        this.$router.push({ path: "/news/index" })
      }
      if (str === "aboutIndex") {
        if (id) {
          this.$router.push({ path: "/about", query: { id: id } })
        } else {
          this.$router.push({ path: "/about" })
        }
      }
      if (str === "serviceIndex") {
        if (id) {
          this.$router.push({ path: "/services/index", query: { id: id } })
        } else {
          this.$router.push({ path: "/services/index" })
        }

      }
    },
    toggleMobileMenu() {
      //console.log('toggleMobileMenu', this.showMobileMenu)
      this.showMobileMenu = !this.showMobileMenu
      // document.body.style.overflow = 'auto'
      document.body.style.overflowX = this.showMobileMenu ? 'hidden' : 'auto'
      // 关闭时也关闭所有下拉
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: transparent;
  position: relative;

  // overflow: auto !important
}

.header {
  background: #f4f8ffe6;
  color: #00eaff;
  padding: 0rem 0;
  box-shadow: 0 2px 16px #8686867d;
  position: sticky;
  top: 0;
  z-index: 1000;

  .header-container {
    max-width: 1600px;
    margin: 0 auto;
    text-align: center;
    // @media (max-width: 1400px) {
      
    // max-width: 1200px;
  
    // }
    // @media (max-width: 992px) {
      
    //   max-width: 992px;
      
    // }
        
    // @media (max-width: 768px) {  
    //    max-width: 768px;

    // }
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    margin-left: 20px;
    padding:12px 0;

    a {
      text-decoration: none;
      color: var(--primary);

      h1 {
        font-size: 1.8rem;
        font-weight: bold;
        margin: 0;
        letter-spacing: 1px;
        text-shadow: 0 2px 16px rgba(0, 234, 255, 0.18);

        @media (max-width: 480px) {
          font-size: 1.5rem;
        }
      }
    }
  }

  .search-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    margin: 0px 0;

    @media (max-width: 992px) {
      display: none;
    }
  }

  .search-box {
    display: flex;
    background: white;
    height: 24px;
    padding: 0 0 0 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    border: 2px solid transparent;
    border-radius: 0px;
    justify-self: center;

  }

  .search-box:focus-within {
    border-color: rgb(17, 99, 167);
    box-shadow: 0 10px 30px rgba(77, 171, 247, 0.4);
  }

  .searchQuery-dropdown {
    position: absolute;
    border-top: none;
    z-index: 1000;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    width: 180px;
  }

  .search-icon {
    color: #6c757d;
    font-size: 0.8rem;
    margin-left:-10px;

    padding: 12px 0;
  }

  .search-input {
    width:100px;
    font-size: 0.8rem;
    flex: 1;
    color: #666;
    border: none;
    outline: none;
    padding: 12px 0;
    background: transparent;
  }

  .search-input::placeholder {
    color: #adb5bd;
  }

  .searchQuery-advance-btn {
    color: var(--secondary);
    border: none;
    border-radius: 0px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    text-wrap: nowrap;
    align-items: center;
    gap: 8px;
    padding: 10px 10px;
    height: 100%;
    text-align: center;
    justify-content: center;
  }

  .searchQuery-advance-btn:hover {
    text-decoration: underline;
  }

  .searchQuery-btn {
    background: var(--secondary);
    color: white;
    border: none;
    border-radius: 0px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    text-wrap: nowrap;
    align-items: center;
    gap: 8px;
    padding: 0px 10px;
    height: 100%;
    text-align: center;
    justify-content: center;
  }

  .searchQuery-btn:hover {
    background: var(--primary);
    box-shadow: 0;
  }


  .search-label {

    .search-options {

      display: flex;
      flex-direction: row;
      justify-content: space-between;

    }
  }

  .search-categories {
    flex: 0 0 280px;
  }

  .search-result {

    padding: 30px 0;
  }

  .search-result.active {}

  .search-result-type {
    padding: 5px 20px;
    color: var(--secondary);
    margin-top: 30px;
    background-color: #fff;
    border: 1px solid var(--secondary);
    cursor: pointer;
  }

  .search-result-type.active {
    color: #fff;
    background-color: var(--secondary)
  }

  .desktop-nav {
    display: flex;
    gap: 2rem;
    justify-content: flex-end;
    align-items: center;
    padding:10px 0 0px 0 ;

    .desktop-menu-btn {
      display: block;
      border: none;
      font-size: 1.5rem;
      color: #0133a5;
      cursor: pointer;
      padding: 1.2rem 0.5rem;
      background-color: transparent;
    }


    .nav-item {
      color: #000000;
      text-decoration: none;
      padding: 1.2rem 0;
      font-weight: 400;
      font-size: 1.1rem;
      background: none;
      border-radius: 0;
      box-shadow: none;
      transition: color 0.3s, border-bottom 0.3s;
      border-bottom: 2px solid transparent;
      position: relative;

      &:hover {
        color: #001dbe;
        border-bottom: 1px solid #0962d09e;
      }

      &.router-link-active {
        color: #2889ff;
        background: none;
        font-weight: 600;
        border-radius: 0;
        box-shadow: none;
        border-bottom: 2px solid #03326b;
      }
    }

    @media (max-width: 992px) {
      display: none;
    }
  }

  .mobile-menu {
    display: none;

    @media (max-width: 992px) {

      display: flex;
      flex-direction: row;
    }
  }

  .mobile-menu-btn {
    display: none;
    border: none;
    font-size: 1.2rem;
    color: var(--secondary);
    cursor: pointer;
    padding: 1.2rem 0.5rem;
    background-color: transparent;

    @media (max-width: 992px) {
      display: block;
    }
  }
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: #fff;
  z-index: 1100;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #eee;

    h3 {
      color: #0133a5;
      margin: 0;
      font-size: 1.3rem;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: #666;
      cursor: pointer;
    }
  }

  .mobile-nav {
    display: flex;
    flex-direction: column;
    padding: 1rem 0;

    .nav-item {
      padding: 1rem 1.5rem;
      color: var(--primary-title);
      text-decoration: none;
      font-size: 1.1rem;
      transition: background-color 0.3s;

      &:hover,
      &.router-link-active {
        background-color: #f5f7fa;
        color: #0962d0;
      }
    }
  }
}

.main {
  flex: 1;
  padding: 0;
  background: transparent;

}


.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

/* 过渡动画 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-280px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.footer {
  background: linear-gradient(180deg, #031c48 0%, #001733 100%);
  color: #eaf6fb;
  position: relative;
  display: block;

  .footer-content {
    // display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    // gap: 2rem;
    // margin: 2rem auto;
    gap: 2rem;
    margin: 2rem auto;
    max-width: 1400px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .footer-section {
    margin: 0 5px;

    // flex-direction:column;
    // align-items: center;


    h3 {
      color: #ffffff;
      padding-bottom: 0.5rem;
      font-size: 1.2rem;
      text-align: left;
      width: fit-content;
      cursor: pointer;
      border-bottom: 0.01rem solid #DDD;
    }

    .footer-menu-container {
      display: flex;
      column-gap: 20;
      flex-direction: column;
      flex-wrap: wrap;
      max-height: 200px;
      img {
        
      height: 100px;
      width: 100px;
      }
    }

    p {
      margin: 0.5rem 0;
      color: #cacaca;
      margin-right: 20px;
      line-height: 1.2;
    }

    p:hover {
      color: #ffffff;
    }
  }

  .footer-bottom {
    border-top: 1px solid #afb5c05e;
    padding: 2rem 0;
    text-align: center;
    a,
    a:link,
    a:visited,
    a:hover,
    a:active {
        text-decoration: none;
    }
    p {
      color: #ffffff;
      margin: 0;
      text-align: center;
    }
  }
}


@media (max-width: 768px) {
  
  .footer {
    .footer-content {
      grid-template-columns: 1fr 1fr;
      text-align: left;
      
    .footer-menu-container {
      column-gap: 10;
      img {
        
      height:100px;
      width: 100px;
      }
    }
    }
  }

}

@media (max-width: 480px) {
  .footer {
    .footer-content {
      grid-template-columns: 1fr;
      
  .footer-menu-container {
      column-gap: 10;
      img {
        
      height: 80px;
      width: 80px;
      }
    }
    }
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .desktop-nav {
    .dropdown {
      .dropdown-menu {
        min-width: 160px;
        width: 100%;

        .dropdown-item {
          padding: 8px 16px;
          font-size: 0.95rem;
        }
      }
    }
  }
}


/* 桌面端下拉菜单样式 */
.dropdown {
  position: relative;
  cursor: pointer;

  &:hover {
    color: #0962d0;
    border-bottom: 1px solid #0962d09e;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 180px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    z-index: 100;
    margin-top: 5px;

    .dropdown-item {
      display: block;
      padding: 10px 20px;
      color: #606266;
      text-decoration: none;
      transition: all 0.3s;

      &:hover {
        color: #0962d0;
        background-color: #f5f7fa;
      }

      &.router-link-active {
        color: #0962d0;
        background-color: #ecf5ff;
      }
    }
  }
}

/* 移动端下拉菜单样式 */
.mobile-dropdown {
  .dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    color: var(--primary-title);
    cursor: pointer;

    .rotate-180 {
      transform: rotate(180deg);
      transition: transform 0.3s;
    }
  }

  .dropdown-content {
    background-color: #f9f9f9;

    .dropdown-item {
      display: block;
      padding: 0.8rem 2rem;
      color: #555;
      text-decoration: none;

      &:hover {
        background-color: #f1f1f1;
      }

      &.router-link-active {
        color: #0962d0;
        background-color: #e6f0ff;
      }
    }
  }
}
</style>